export const getPrice = (price: string | number | null | undefined): string => {
    if (price === null || price === undefined) {
        return 'Unavailable';
    }

    const num = typeof price === 'string' ? Number.parseFloat(price) : price;

    if (Number.isNaN(num) || num === 0) {
        return 'Unavailable';
    }

    return `$${num.toLocaleString('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
    })}`;
};
